/* Lead-attribution capture.
 *
 * On first visit we snapshot the landing page + referrer + UTM parameters and
 * persist them in sessionStorage so they survive in-app navigations. Any lead
 * form (estimate wizard, quote drawer, contact form) reads getAttribution()
 * at submit time and posts it alongside the form data.
 */
const KEY = "cloudlab_attr_v1";

function readStore() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function writeStore(data) {
  try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch { /* quota */ }
}

function deviceType() {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (/tablet|ipad/i.test(ua)) return "tablet";
  if (/mobile|iphone|android/i.test(ua)) return "mobile";
  return "desktop";
}

function pickUtm(sp) {
  const out = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => {
    const v = sp.get(k);
    if (v) out[k] = v;
  });
  return out;
}

/** Called once at app boot (App.js). Snapshots UTM + landing page + referrer
 * — only writes if we don't already have a snapshot in this session. */
export function initAttribution() {
  if (typeof window === "undefined") return;
  const existing = readStore();
  const sp = new URLSearchParams(window.location.search);
  const utms = pickUtm(sp);
  if (existing && !Object.keys(utms).length) {
    // Nothing to update — keep the first-touch attribution
    return;
  }
  const snapshot = {
    landing_page: existing?.landing_page || window.location.pathname + window.location.search,
    referrer: existing?.referrer || document.referrer || null,
    device: deviceType(),
    // First-touch UTMs win — do NOT overwrite unless there weren't any before
    utm_source: existing?.utm_source || utms.utm_source || null,
    utm_medium: existing?.utm_medium || utms.utm_medium || null,
    utm_campaign: existing?.utm_campaign || utms.utm_campaign || null,
    utm_term: existing?.utm_term || utms.utm_term || null,
    utm_content: existing?.utm_content || utms.utm_content || null,
    first_seen_at: existing?.first_seen_at || new Date().toISOString(),
  };
  writeStore(snapshot);
}

/** Build the attribution payload posted with a lead. Includes the current page
 * so we know where they converted, not just where they entered. */
export function getAttribution() {
  const s = readStore() || {};
  return {
    landing_page: s.landing_page || null,
    current_page: typeof window !== "undefined" ? window.location.pathname : null,
    referrer: s.referrer || null,
    utm_source: s.utm_source || null,
    utm_medium: s.utm_medium || null,
    utm_campaign: s.utm_campaign || null,
    utm_term: s.utm_term || null,
    utm_content: s.utm_content || null,
    device: s.device || deviceType(),
    submitted_at: new Date().toISOString(),
  };
}
